import { useSearchParams } from "next/navigation";

import { ENV } from "#app/env";
import {
  sessionStorageKeys,
  useSessionStorage,
} from "#app/lib/useSessionStorage";

export function useOutageBypass() {
  const searchParams = useSearchParams();
  const [outageBypassCode, setoutageBypassCode] = useSessionStorage<
    string | null
  >(sessionStorageKeys.outageBypassCode, null);

  const outageBypassCodeSearchParam = searchParams.get("outageBypassCode");
  if (ENV.outageBypassCode === outageBypassCodeSearchParam) {
    setoutageBypassCode(ENV.outageBypassCode);
    return true;
  }

  return ENV.outageBypassCode === outageBypassCode;
}

export function useOutageBypassPersistedCode() {
  const [outageBypassCode] = useSessionStorage<string | null>(
    sessionStorageKeys.outageBypassCode,
    null,
  );

  const outageBypass = useOutageBypass();
  if (outageBypass) {
    return outageBypassCode;
  }

  return undefined;
}
